/*** IMPORTS FROM imports-loader ***/


module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};




//////////////////
// WEBPACK FOOTER
// ../~/es-abstract/helpers/isNaN.js
// module id = 155
// module chunks = 3